export const entitlements = {
    startAuth: ['WMS.Unknown'],
    killSwitchAccess: ['WMS.SuperAdmin'],
    componentsCreation: ['WMS.DataAdmin', 'WMS.SuperAdmin'],
    newAlert: ['WMS.DataAdmin', 'WMS.SuperAdmin'],
    apiValidator: ['WMS.SuperAdmin', 'WMS.DataAdmin'],
    email: ['WMS.SuperAdmin']
}